import { render } from "./TheCreditRuleDialog.vue?vue&type=template&id=4dd571ec&scoped=true&ts=true"
import script from "./TheCreditRuleDialog.vue?vue&type=script&lang=ts"
export * from "./TheCreditRuleDialog.vue?vue&type=script&lang=ts"

import "./TheCreditRuleDialog.vue?vue&type=style&index=0&id=4dd571ec&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd571ec"]])

export default __exports__